import React from 'react';
import _ from 'lodash';
import { ToastType } from 'store/ui/toasts/toastsTypes';
import i18n from 'i18n';
import store from 'store/configureStore';
import { showToastNotification } from 'store/ui/toasts/toastsActions';
import MixpanelService from 'utils/mixpanelService';
import { COPY_TO_CLIPBOARD } from 'utils/mixpanelEvents';
import clsx from 'clsx';

type CopyToClipboardProps = {
  /** Identifier of the button - make sure it is unique enough */
  id?: string;

  /** Text to be stored in the clipboard */
  textToCopy: string;

  /** Text to be shown on hover */
  title: string;

  /** React children */
  children: any;

  /** Custom toast message */
  customToastMsg?: string;

  /** Custom padding */
  paddingSize?: number;

  className?: string;

  disabled?: boolean;
};

/**
 * Copies text to the clipboard.
 * @param valueToCopy
 * @param customToastMsg
 */
export const copyToClipboard = (valueToCopy: string, customToastMsg?: string) => {
  try {
    const el = document.createElement('textarea');
    el.value = valueToCopy;
    el.setAttribute('readonly', '');
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);

    if (!customToastMsg) {
      store.dispatch(
        showToastNotification(ToastType.Success, i18n.t('mockServices:successMsgs.copyEndpointSuccessMsg')),
      );
    } else {
      store.dispatch(showToastNotification(ToastType.Success, customToastMsg));
    }

    MixpanelService.track(COPY_TO_CLIPBOARD());
  } catch (e) {
    store.dispatch(showToastNotification(ToastType.Danger, 'Cannot copy to the clipboard'));
  }
};

/**
 * Button which copies text to the clipboard.
 * @param props
 * @constructor
 */
const CopyToClipboardButton = (props: CopyToClipboardProps) => {
  const { id, textToCopy, title, children, customToastMsg } = props;

  return (
    <button
      className={clsx('btn btn-link btn-no-hover', props.className)}
      title={title}
      disabled={props.disabled}
      id={id ? id : _.uniqueId('copy-')}
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        copyToClipboard(textToCopy, customToastMsg);
      }}
      style={{ padding: props.paddingSize ? props.paddingSize + 'px' : undefined }}
    >
      {children}
    </button>
  );
};

export default CopyToClipboardButton;
